import isBrowser from './isBrowser';

type NetworkInformation = {
  type: string;
  downlink: string;
  rtt: string;
  downlinkMax: string;
  effectiveType: string;
  saveData: boolean;
};

export const getNetworkInfo = (): Partial<NetworkInformation> => {
  if (!isBrowser()) {
    return {};
  }
  const connection =
    /** @type {Navigator & {connection: NetworkInformation}} */ navigator.connection;
  return connection || {};
};
